(() => {
  // shared/ids.js
  var EXPERIMENT_ID = "bb-gift-mix-20261018";
  var GIFT_MARKER = "bb-giftmix-v1";
  var IDS = Object.freeze({
    heroProduct: "8491980619984",
    heroVariants: Object.freeze(["45197484687568", "45197610025168", "45197610057936", "45197610090704"]),
    miniProduct: "8491980652752",
    miniVariant: "45197484753104",
    refillProduct: "8469929361616",
    refillVariant: "45069609500880",
    targetsProduct: "8469928280272",
    targetsVariant: "45069606584528",
    wrapProduct: "8410157088976",
    wrapVariant: "44897273774288",
    protectionProduct: "8497333043408",
    protectionVariant: "45263113781456"
  });
  var HERO_COLORS = Object.freeze({
    "45197484687568": "Classic",
    "45197610025168": "Blue",
    "45197610057936": "White",
    "45197610090704": "Camo"
  });
  var NATIVE_CONTROL_NODES = Object.freeze({
    miniForTwo: { id: "gid://shopify/DiscountAutomaticNode/1145522946256", title: "BRICK BLASTER \u2014 Buy 2, FREE Mini Blaster" },
    fourthFree: { id: "gid://shopify/DiscountAutomaticNode/1145522979024", title: "BRICK BLASTER \u2014 Buy 3, Get 1 FREE" }
  });
  var TERMS = Object.freeze({
    version: "bbp-holiday-2026-v1",
    priceCents: 599,
    enrollmentEndsExclusive: "2026-12-26T05:00:00.000Z",
    coverageEndsExclusive: "2027-12-26T05:00:00.000Z",
    expiryLabel: "December 25, 2027 (Eastern Time)",
    optInDefault: false,
    checkbox: "Protect every blaster in this order",
    shortTerms: "Pay once for this order. All blasters in this order, including free blasters and any blaster added to this same order after checkout, are covered through December 25, 2027 (Eastern Time). If a blaster breaks during that time, we replace it."
  });
  var POST_PURCHASE = Object.freeze({
    offerId: "bb-one-more-20-off",
    timerSeconds: 900,
    fixedOffAmount: 20,
    expectedUnitPrice: "39.99",
    expectedOfferPrice: "19.99",
    minHeroQuantity: 1,
    maxHeroQuantity: 2
  });
  function numericId(value) {
    const raw = String(value ?? "");
    if (!/^(?:gid:\/\/shopify\/(?:Product|ProductVariant)\/)?[0-9]+$/.test(raw)) return null;
    return raw.split("/").pop();
  }

  // shared/arm-token.js
  var ARM_TOKEN_PATTERN = /^(bb1|bq1)\.([a-z0-9]{1,8})\.([A-Za-z0-9_-]{22})\.([cg])\.(20[0-9]{6})\.([0-9a-f]{32})$/;
  var ARM_LETTER = Object.freeze({ control: "c", gifts: "g" });
  function parseArmToken(value) {
    if (typeof value !== "string" || value.length > 96) return null;
    const match = ARM_TOKEN_PATTERN.exec(value);
    if (!match) return null;
    const lastDay = match[5];
    const month = Number(lastDay.slice(4, 6));
    const day = Number(lastDay.slice(6, 8));
    if (month < 1 || month > 12 || day < 1 || day > 31) return null;
    return {
      prefix: match[1],
      qa: match[1] === "bq1",
      kid: match[2],
      uid: match[3],
      armLetter: match[4],
      arm: match[4] === "g" ? "gifts" : "control",
      lastDay,
      tag: match[6],
      message: `${match[1]}.${match[2]}.${match[3]}.${match[4]}.${lastDay}`
    };
  }

  // ../next-steps-20261018/offer-contract.mjs
  var IDS2 = Object.freeze({
    heroProduct: "8491980619984",
    heroVariants: Object.freeze(["45197484687568", "45197610025168", "45197610057936", "45197610090704"]),
    miniProduct: "8491980652752",
    miniVariant: "45197484753104",
    refillProduct: "8469929361616",
    refillVariant: "45069609500880",
    targetsProduct: "8469928280272",
    targetsVariant: "45069606584528",
    wrapProduct: "8410157088976",
    wrapVariant: "44897273774288",
    protectionProduct: "8497333043408",
    protectionVariant: "45263113781456",
    onlineStorePublication: "122107887824"
  });
  var TERMS2 = Object.freeze({
    version: "bbp-holiday-2026-v1",
    priceCents: 599,
    feeUnit: "one_original_order",
    coverageScope: "all_blaster_units_in_original_order_including_free_and_accepted_post_purchase",
    starts: "purchase",
    // Implementation recommendations under "figure it out yourself", not a quoted Emi decision.
    enrollmentEndsExclusive: "2026-12-26T05:00:00.000Z",
    coverageEndsExclusive: "2027-12-26T05:00:00.000Z",
    expiryLabel: "December 25, 2027 (Eastern Time)",
    optInDefault: false,
    checkbox: "Protect every blaster in this order",
    shortTerms: "Pay once for this order. All blasters in this order, including free blasters and any blaster added to this same order after checkout, are covered through December 25, 2027 (Eastern Time). If a blaster breaks during that time, we replace it."
  });
  function numericId2(value) {
    const raw = String(value ?? "");
    if (!/^(?:gid:\/\/shopify\/(?:Product|ProductVariant)\/)?[0-9]+$/.test(raw)) return null;
    return raw.split("/").pop();
  }
  function variantId(line) {
    return numericId2(line.variant_id ?? line.variantId ?? line.variant?.id ?? line.id);
  }
  function quantity(line) {
    const value = Number(line.quantity);
    if (!Number.isSafeInteger(value) || value < 0) throw new TypeError("Invalid line quantity");
    return value;
  }
  function isBlaster(line) {
    const id = variantId(line);
    return IDS2.heroVariants.includes(id) || id === IDS2.miniVariant;
  }
  function blasterUnitCount(lines) {
    return lines.reduce((total, line) => total + (isBlaster(line) ? quantity(line) : 0), 0);
  }
  function protectionReconciliation(cart, nowMs = Date.now()) {
    if (!Array.isArray(cart?.items)) throw new TypeError("Cart items required");
    const eligibleUnits = blasterUnitCount(cart.items);
    const updates = {};
    let retained = false;
    let serviceUnits = 0;
    for (const line of cart.items) {
      if (variantId(line) !== IDS2.protectionVariant) continue;
      serviceUnits += quantity(line);
      if (typeof line.key !== "string" || line.key.length === 0) throw new TypeError("Exact line key required");
      const keep = eligibleUnits > 0 && !retained && quantity(line) > 0;
      const wanted = keep ? 1 : 0;
      if (quantity(line) !== wanted) updates[line.key] = wanted;
      if (keep) retained = true;
    }
    return {
      updates,
      coveredBlasterUnitsInCurrentCart: eligibleUnits,
      serviceUnitsBefore: serviceUnits,
      serviceUnitsAfter: retained ? 1 : 0,
      mayEnroll: eligibleUnits > 0 && nowMs < Date.parse(TERMS2.enrollmentEndsExclusive),
      // This is an order-wide entitlement, not a frozen cap on units at ATC.
      coverageScope: TERMS2.coverageScope
    };
  }
  function protectionAdditions({ cart, incomingItems, optedIn, nowMs = Date.now() }) {
    if (typeof optedIn !== "boolean" || !Array.isArray(incomingItems)) throw new TypeError("Explicit opt-in and items required");
    const state = protectionReconciliation(cart, nowMs);
    const incoming = incomingItems.filter((line) => variantId(line) !== IDS2.protectionVariant);
    const eligibleUnits = blasterUnitCount(cart.items) + blasterUnitCount(incoming);
    if (!optedIn || state.serviceUnitsAfter === 1 || eligibleUnits === 0 || nowMs >= Date.parse(TERMS2.enrollmentEndsExclusive)) return [];
    return [{ id: Number(IDS2.protectionVariant), quantity: 1, properties: {
      "_bbp_terms": TERMS2.version,
      "_bbp_coverage": "all-blasters-in-original-order",
      "_bbp_ends_exclusive": TERMS2.coverageEndsExclusive
    } }];
  }

  // theme/src/cart-contract.js
  var HERO = new Set(IDS.heroVariants);
  var rewards = /* @__PURE__ */ new Set([IDS.refillVariant, IDS.targetsVariant, IDS.wrapVariant]);
  var variant = (line) => String(line.variant_id ?? line.id);
  function registerHeroVariants(ids) {
    for (const id of Array.isArray(ids) ? ids : []) {
      const n = numericId(id);
      if (n) HERO.add(n);
    }
  }
  var isHero = (line) => String(line?.product_id ?? "") === IDS.heroProduct || HERO.has(variant(line));
  var heroQuantity = (cart) => cart.items.reduce((n, l) => n + (isHero(l) ? l.quantity : 0), 0);
  function mixed(cart, letter) {
    return cart.items.some((line) => line.properties?._bb_arm && line.properties._bb_arm !== letter);
  }
  function giftPlan(cart, arm2, { wrapDeclined: wrapDeclined2 = false } = {}) {
    const quantity2 = heroQuantity(cart);
    const tier3 = wrapDeclined2 ? [IDS.targetsVariant] : [IDS.targetsVariant, IDS.wrapVariant];
    const wanted = arm2 === "gifts" ? quantity2 === 2 ? [IDS.refillVariant] : quantity2 >= 3 ? tier3 : [] : [];
    const updates = {}, adds = [], changes = [], kept = /* @__PURE__ */ new Set();
    for (const line of cart.items) {
      if (!line.key) throw new TypeError("Exact line key required");
      const id = variant(line), properties = line.properties ?? {};
      if (properties._bos_gift !== GIFT_MARKER) continue;
      if (!rewards.has(id)) continue;
      const keep = wanted.includes(id) && !kept.has(id);
      if (keep) {
        kept.add(id);
        if (line.quantity !== 1) updates[line.key] = 1;
      } else if (id === IDS.wrapVariant && properties._bb_wrap_reused === "1" && !wrapDeclined2) {
        const restored = { ...properties };
        delete restored._bos_gift;
        delete restored._bb_wrap_reused;
        delete restored._bb_arm;
        changes.push({ id: line.key, quantity: 1, properties: restored });
      } else updates[line.key] = 0;
    }
    for (const id of wanted) if (!kept.has(id)) {
      const props = { _bos_gift: GIFT_MARKER, _bb_arm: "g", _bb_bundle: "cart-wide-v1" };
      if (id === IDS.refillVariant) {
        props._bb_source_variant = "45217057013939";
        props._bb_fulfillment = "Darts + Casings CJYD189218701AZ";
      }
      if (id === IDS.targetsVariant) {
        props._bb_source_variant = "45217054228659";
        props._bb_fulfillment = "Targets; supplier route, source variant 45217054228659";
      }
      if (id === IDS.wrapVariant) {
        const paid = cart.items.find((l) => variant(l) === id && l.quantity > 0 && l.properties?._bos_gift !== GIFT_MARKER);
        if (paid) {
          props._bb_wrap_reused = "1";
          if (paid.quantity === 1) changes.push({ id: paid.key, quantity: 1, properties: { ...paid.properties ?? {}, ...props } });
          else {
            updates[paid.key] = paid.quantity - 1;
            adds.push({ id: Number(id), quantity: 1, properties: props });
          }
          continue;
        }
      }
      adds.push({ id: Number(id), quantity: 1, properties: props });
    }
    const num = (value) => {
      const n = Number(value);
      return Number.isFinite(n) ? n : 0;
    };
    let miniKept = false;
    for (const line of cart.items) {
      const flag = line.properties?._bb_gift;
      if (variant(line) !== IDS.miniVariant || flag == null || String(flag) === "") continue;
      if (arm2 !== "control" || quantity2 < 2 || miniKept) updates[line.key] = 0;
      else if (num(line.quantity) > 1) {
        updates[line.key] = 1;
        miniKept = true;
      } else if (num(line.final_line_price) > 0) updates[line.key] = 0;
      else miniKept = true;
    }
    return { updates, adds, changes };
  }
  function addOnOnlyClear(cart, { updates = {}, changes = [], adds = [] }, addOnHandles2 = []) {
    const items = cart.items ?? [];
    const changed = Object.keys(updates).length > 0 || changes.length > 0 || adds.length > 0;
    if (!changed || items.length === 0) return null;
    const handles = new Set(addOnHandles2);
    const ours = (line) => variant(line) === IDS.protectionVariant || line.properties?._bos_gift === GIFT_MARKER && rewards.has(variant(line));
    const othersLeft = items.some((line) => {
      const gone = Object.prototype.hasOwnProperty.call(updates, line.key) && updates[line.key] === 0;
      return !gone && !handles.has(String(line.handle || "")) && !ours(line);
    });
    if (othersLeft) return null;
    const all = {};
    for (const line of items) {
      if (!line.key) throw new TypeError("Exact line key required");
      all[line.key] = 0;
    }
    return all;
  }
  function allowReload(history, nowMs, { max = 2, windowMs = 15e3 } = {}) {
    const recent = (Array.isArray(history) ? history : []).filter((t) => Number.isFinite(t) && nowMs - t < windowMs && t <= nowMs);
    return { allowed: recent.length < max, history: recent.length < max ? [...recent, nowMs] : recent };
  }
  function preparePack(items, cart, { arm: arm2, tier, optedIn, protectionEnabled, nowMs = Date.now() }) {
    const treatment = arm2 === "gifts";
    const heroes = items.filter((i) => isHero(i));
    const other = items.filter((i) => !isHero(i) && (!treatment || String(i.id) !== IDS.miniVariant) && String(i.id) !== IDS.protectionVariant);
    if (treatment && tier === 3) {
      let remaining = 3;
      for (const item of heroes) {
        const q = Math.min(item.quantity, remaining);
        item.quantity = q;
        remaining -= q;
      }
    }
    const output = [...other, ...heroes.filter((i) => i.quantity > 0)];
    const deduped = output.filter((i) => String(i.id) !== IDS.wrapVariant || !cart.items.some((l) => variant(l) === IDS.wrapVariant && l.quantity > 0));
    if (protectionEnabled) deduped.push(...protectionAdditions({ cart, incomingItems: deduped, optedIn: optedIn === true, nowMs }));
    return deduped;
  }

  // theme/src/arm-carrier.js
  var STORED_ARM_KEY = "bbVerifiedArmV1";
  var QA_ARM_KEY = "bbQaArmV1";
  var QA_PARAM = "bb_qa";
  function shopDay(nowMs) {
    try {
      const parts = {};
      for (const part of new Intl.DateTimeFormat("en-US", {
        timeZone: "America/New_York",
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }).formatToParts(nowMs)) parts[part.type] = part.value;
      const day = `${parts.year}${parts.month}${parts.day}`;
      if (/^20[0-9]{6}$/.test(day)) return day;
    } catch {
    }
    return new Date(nowMs - 5 * 36e5).toISOString().slice(0, 10).replace(/-/g, "");
  }
  function usableToken(value, { qa: qa2, nowMs }) {
    const token = parseArmToken(value);
    return token && token.qa === qa2 && token.lastDay >= shopDay(nowMs) ? token : null;
  }
  function qaOverride(search, session, nowMs) {
    let supplied = null;
    try {
      supplied = new URLSearchParams(search ?? "").get(QA_PARAM);
    } catch {
    }
    try {
      if (supplied === "clear") session.removeItem(QA_ARM_KEY);
      else if (supplied && usableToken(supplied, { qa: true, nowMs })) session.setItem(QA_ARM_KEY, supplied);
    } catch {
    }
    let value = null;
    try {
      value = session.getItem(QA_ARM_KEY);
    } catch {
    }
    const token = usableToken(value, { qa: true, nowMs });
    if (value != null && !token) {
      try {
        session.removeItem(QA_ARM_KEY);
      } catch {
      }
    }
    return token ? { value, token } : null;
  }
  function fallbackArm({ carried, stored, nowMs }) {
    if (stored?.enabled === false) return null;
    const onCart = usableToken(carried, { qa: false, nowMs });
    if (onCart) return { arm: onCart.arm, token: carried, carried: true };
    const kept = usableToken(stored?.token, { qa: false, nowMs });
    return kept ? { arm: kept.arm, token: stored.token, carried: false } : null;
  }

  // theme/src/runtime.js
  var CONFIG = document.querySelector("[data-bb-tests-config]");
  var cfg = CONFIG ? JSON.parse(CONFIG.textContent) : { giftExperimentEnabled: false, protectionEnabled: false };
  registerHeroVariants(cfg.heroVariantIds);
  var qa = null;
  try {
    qa = qaOverride(location.search, window.sessionStorage, Date.now());
  } catch {
  }
  var assignment = null;
  var loaded = null;
  var queue = Promise.resolve();
  var scheduled = null;
  function exclusive(work) {
    const task = queue.then(work);
    queue = task.catch(() => {
    });
    return task;
  }
  var url = (path) => `${(window.Shopify?.routes?.root ?? "/").replace(/\/$/, "")}/cart${path}.js`;
  async function json(path, body) {
    const response = await fetch(url(path), {
      credentials: "same-origin",
      ...body === void 0 ? {} : { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) }
    });
    if (!response.ok) throw new Error("cart_unavailable");
    return response.json();
  }
  function market() {
    return cfg.countryCode === "US" && cfg.currencyCode === "USD";
  }
  async function armRequest(path, body) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 3500);
    try {
      const response = await fetch(`${cfg.apiOrigin}/v1/${path}`, {
        method: "POST",
        signal: controller.signal,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      if (!response.ok) throw new Error("assignment_unavailable");
      return response.json();
    } finally {
      clearTimeout(timer);
    }
  }
  function storedArm() {
    try {
      const value = JSON.parse(localStorage.getItem(STORED_ARM_KEY) ?? "null");
      return value && typeof value === "object" ? value : null;
    } catch {
      return null;
    }
  }
  function storeArm(value) {
    try {
      localStorage.setItem(STORED_ARM_KEY, JSON.stringify(value));
    } catch {
    }
  }
  function armAttributes(token, arm2) {
    return { _bb_arm: token, bb_experiment: EXPERIMENT_ID, bb_arm: arm2, bb_uid: token.split(".")[2] };
  }
  async function resolveArm(cart) {
    if (!market()) return null;
    let onCart = cart.attributes?._bb_arm;
    if (qa) {
      if (onCart !== qa.value) await json("/update", { attributes: armAttributes(qa.value, qa.token.arm) });
      return { enabled: true, arm: qa.token.arm, token: qa.value, qa: true };
    }
    if (parseArmToken(onCart)?.qa) {
      await json("/update", { attributes: { _bb_arm: "", bb_experiment: "", bb_arm: "", bb_uid: "" } });
      onCart = "";
    }
    if (!cfg.giftExperimentEnabled) return null;
    const stored = storedArm();
    const previous = onCart || stored?.token;
    let response = null;
    try {
      response = await armRequest("arm", previous ? { previousToken: previous } : {});
    } catch {
    }
    if (response?.enabled === false) {
      storeArm({ ...stored, enabled: false });
      return null;
    }
    if (response?.enabled === true && ["control", "gifts"].includes(response.arm) && typeof response.token === "string") {
      storeArm(response);
      try {
        await json("/update", { attributes: armAttributes(response.token, response.arm) });
      } catch (error) {
        if (onCart !== response.token) throw error;
      }
      return response;
    }
    const kept = fallbackArm({ carried: onCart, stored, nowMs: Date.now() });
    if (!kept) return null;
    if (!kept.carried) await json("/update", { attributes: armAttributes(kept.token, kept.arm) });
    return { enabled: true, arm: kept.arm, token: kept.token, fallback: true };
  }
  async function load(cart) {
    if (loaded) return loaded;
    loaded = resolveArm(cart).then((value) => {
      assignment = value;
    }, () => {
      assignment = null;
    });
    return loaded;
  }
  function arm(cart) {
    const letter = assignment?.arm === "gifts" ? "g" : "c";
    return assignment?.arm === "gifts" && !mixed(cart, letter) ? "gifts" : "control";
  }
  function wrapDeclined() {
    const toggle = document.querySelector(`cart-drawer cart-drawer-upsell[data-toggle="true"][data-id="${IDS.wrapVariant}"]`);
    return Boolean(toggle) && toggle.dataset.selected === "false";
  }
  function addOnHandles() {
    return Array.from(document.querySelectorAll('cart-drawer cart-drawer-upsell[data-toggle="true"]'), (u) => u.dataset.handle);
  }
  function lock(on) {
    document.querySelectorAll("#CartDrawer-CartItems, #main-cart-items").forEach((el) => el.classList.toggle("cart__items--disabled", on));
  }
  async function normalize(cart) {
    const service = protectionReconciliation(cart);
    const gifts = giftPlan(cart, arm(cart), { wrapDeclined: wrapDeclined() });
    let updates = { ...service.updates, ...gifts.updates };
    let changes = gifts.changes;
    let adds = gifts.adds.length && assignment ? gifts.adds : [];
    const clear = addOnOnlyClear(cart, { updates, changes, adds }, addOnHandles());
    if (clear) {
      updates = clear;
      changes = [];
      adds = [];
    }
    if (!Object.keys(updates).length && !changes.length && !adds.length) return { cart, changed: false };
    lock(true);
    try {
      if (Object.keys(updates).length) await json("/update", { updates });
      for (const change of changes) await json("/change", change);
      if (adds.length) await json("/add", { items: adds });
      return { cart: await json(""), changed: true };
    } catch (error) {
      lock(false);
      throw error;
    }
  }
  function reloadCartPage() {
    let history = [];
    try {
      history = JSON.parse(sessionStorage.getItem("bbReconcileReloadsV1") ?? "[]");
    } catch {
    }
    const decision = allowReload(history, Date.now());
    try {
      sessionStorage.setItem("bbReconcileReloadsV1", JSON.stringify(decision.history));
    } catch {
    }
    if (decision.allowed) {
      location.reload();
      return true;
    }
    lock(false);
    return false;
  }
  async function renderSections(cart) {
    try {
      const response = await fetch(`${location.pathname}?sections=cart-drawer,cart-icon-bubble`, { credentials: "same-origin" });
      if (!response.ok) return;
      const sectionsData = await response.json();
      const drawer = document.querySelector("cart-drawer");
      if (drawer?.renderContents && sectionsData["cart-drawer"]) {
        drawer.renderContents({ sections: sectionsData }, true);
        if (cart) drawer.classList.toggle("is-empty", cart.item_count === 0);
      }
    } finally {
      lock(false);
    }
  }
  function paintProtection(cart) {
    const selected = cart.items.some((l) => variant(l) === IDS.protectionVariant && l.quantity > 0);
    document.querySelectorAll("[data-bbp-cart]").forEach((el) => {
      el.hidden = !(cfg.protectionEnabled && market() && cfg.protectionVariantAvailable);
      const checkbox = el.querySelector("input[data-bbp-opt]");
      if (checkbox) checkbox.checked = selected;
    });
  }
  async function reconcile() {
    return exclusive(async () => {
      let cart = await json("");
      await load(cart);
      const result = await normalize(cart);
      paintProtection(result.cart);
      if (result.changed) {
        if (document.querySelector("cart-items") && reloadCartPage()) return;
        await renderSections(result.cart);
      }
      return result.cart;
    });
  }
  function schedule() {
    clearTimeout(scheduled);
    scheduled = setTimeout(() => {
      reconcile().catch(() => {
      });
    }, 200);
  }
  async function addPack(items, root) {
    return exclusive(async () => {
      let cart = await json("");
      await load(cart);
      const optedIn = root.querySelector("[data-bbp-opt]")?.checked === true;
      const incoming = preparePack(items, cart, {
        arm: arm(cart),
        tier: Number(root.dataset.bbSelected),
        optedIn,
        protectionEnabled: cfg.protectionEnabled && market() && cfg.protectionVariantAvailable
      });
      await json("/add", { items: incoming });
      try {
        await normalize(await json(""));
      } catch {
        lock(false);
        schedule();
      }
      try {
        const response = await fetch(`${location.pathname}?sections=cart-drawer,cart-icon-bubble`, { credentials: "same-origin" });
        if (response.ok) return { sections: await response.json() };
      } catch {
      }
      lock(false);
      return {};
    });
  }
  async function bindOffer(root) {
    root.style.visibility = (cfg.giftExperimentEnabled || qa) && market() ? "hidden" : "";
    let cart = await json("");
    await exclusive(() => load(cart));
    if (arm(cart) === "gifts") {
      const data = root.querySelector("[data-bb-offer-data]");
      const offer = JSON.parse(data.textContent);
      offer.tiers["2"].mini = 0;
      offer.tiers["3"].blaster = 3;
      data.textContent = JSON.stringify(offer);
      root.__bbCfg = offer;
      root.selectedQuantity = offer.tiers[String(root.dataset.bbSelected || 2)].blaster;
      for (const tier of [2, 3]) {
        const bar = root.querySelector(`[data-bb-tier="${tier}"]`);
        bar.querySelector(".bb-bar__title").textContent = `Buy ${tier}`;
        bar.querySelector(".bb-bar__free")?.setAttribute("hidden", "");
        bar.querySelector(".bb-bar__price .bb-bar__was")?.setAttribute("hidden", "");
        const line = bar.querySelector("[data-bb-gift-line]");
        if (line) {
          line.hidden = false;
          line.textContent = tier === 2 ? "+ FREE Darts + Casings" : "+ FREE Targets + Gift Wrap";
        }
      }
      root.dataset.bbArm = "gifts";
    } else root.dataset.bbArm = "control";
    root.querySelectorAll("[data-bbp-pdp]").forEach((el) => {
      el.hidden = !(cfg.protectionEnabled && market() && cfg.protectionVariantAvailable);
    });
    root.style.visibility = "";
    if (assignment && !assignment.qa && !mixed(cart, assignment.arm === "gifts" ? "g" : "c")) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5)) {
          observer.disconnect();
          armRequest("exposure", { token: assignment.token, productId: IDS.heroProduct }).catch(() => {
          });
        }
      }, { threshold: 0.5 });
      observer.observe(root);
    }
  }
  window.BrickOfferTests = { addPack, reconcile, refresh: renderSections, bindOffer, exclusive, treatment: () => assignment?.arm === "gifts" };
  document.addEventListener("change", (event) => {
    const box = event.target.closest?.("[data-bbp-cart] input[data-bbp-opt]");
    if (!box) return;
    const opted = box.checked;
    box.disabled = true;
    exclusive(async () => {
      const cart = await json("");
      await load(cart);
      const updates = {};
      if (!opted) cart.items.filter((l) => variant(l) === IDS.protectionVariant).forEach((l) => {
        updates[l.key] = 0;
      });
      if (Object.keys(updates).length) await json("/update", { updates });
      if (opted && cfg.protectionEnabled && market()) {
        const additions = preparePack([], cart, {
          arm: arm(cart),
          tier: 1,
          optedIn: true,
          protectionEnabled: cfg.protectionVariantAvailable
        }).filter((i) => String(i.id) === IDS.protectionVariant);
        if (additions.length) await json("/add", { items: additions });
      }
      const result = await normalize(await json(""));
      if (document.querySelector("cart-items") && reloadCartPage()) return;
      await renderSections(result.cart);
    }).catch(() => {
      box.checked = !opted;
    }).finally(() => {
      box.disabled = false;
    });
  });
  var themeHooked = false;
  function hookTheme() {
    if (themeHooked || typeof window.subscribe !== "function") return;
    let events = null;
    try {
      events = typeof PUB_SUB_EVENTS === "object" && PUB_SUB_EVENTS ? PUB_SUB_EVENTS : null;
    } catch {
    }
    try {
      window.subscribe(events?.cartUpdate ?? "cart-update", () => schedule());
      themeHooked = true;
    } catch {
    }
  }
  function start() {
    hookTheme();
    document.querySelectorAll("[data-bb-offer]").forEach((root) => {
      root.__bbTestsReady = bindOffer(root).catch(() => {
        root.style.visibility = "";
      });
    });
    const drawer = document.querySelector("cart-drawer");
    if (drawer) new MutationObserver(schedule).observe(drawer, { childList: true, subtree: true });
    schedule();
  }
  ["bb:cart:changed", "cartQuantityUpdated", "cart:updated", "cart:refresh"].forEach((name) => document.addEventListener(name, schedule));
  window.addEventListener("pageshow", schedule);
  document.addEventListener("DOMContentLoaded", hookTheme);
  window.addEventListener("load", hookTheme);
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
